import React, { useCallback, useEffect, useState } from "react";
//img
import profileImg from "../../../assets/images/png/Profile.png";
import plusIcon from "../../../assets/images/svg/plusIcon.png";
//css
import classes from "./VendorsTab.module.css";
//img
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import deletePopupImg from "../../../assets/images/png/Group 2@2x.png";
//components
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import DateBar from "../../../components/common/DateBar/DateBar";
import NotificationBell from "../../../components/common/NotificationBell/NotificationBell";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import PaginationComponent from "../../../components/common/Pagination/PaginationComponent";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DataTable from "../../../components/common/DataTable/DataTableSorting";
import { Box, Button, Fade, Modal } from "@mui/material";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import {
  ArrowLeft,
  Visibility,
  FileDownloadOutlined,
  GroupsOutlined,
  CheckCircleOutline,
  PendingActionsOutlined,
  VerifiedUserOutlined,
  FactCheckOutlined,
} from "@mui/icons-material";
import DetailsTab from "../../../components/Dashboard/DetailsTab/DetailsTab";
import ImageView from "../../../components/Dashboard/ImageView/ImageView";
import { isPdfUrl } from "../../../utils/mediaUrl";
//api and redux
import { API_ENDPOINT } from "../../../services/api/resources";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setVendorsData } from "../../../features/VendorDataSlice";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import {
  emptyCheck,
  validateEmail,
  validateFile,
} from "../../../utils/validations";
import { nextPageClick, previouPageClick } from "../../../utils/pagination";
//custom hooks
import useFetchData from "../../../hooks/useFetchData";
import DFreeSoloInput from "../../../components/Dashboard/DashboardInputs/DFreeSoloInput";
import { getUniqueData } from "../../../utils/getUniqueData";
import DropdownBtnOutlined from "../../../components/Dashboard/DropdownButtons/DropdownBtnOutlined/DropdownBtnOutlined";
import { downloadFile } from "../../../utils/downloadFile";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DefaultLabel from "../../../components/Dashboard/DefaultLabel/DefaultLabel";
import DFileUpload from "../../../components/Dashboard/DashboardInputs/DFileUpload";
import sampleCSV from "../../../assets/files/Sample Vendor CSV.csv";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import Tooltip from "@mui/material/Tooltip";
import VendorItemMapping from "./VendorItemMapping";
import { useOfflineVendorMaster } from "../../../offline/hooks/useOfflineVendorMaster";
import { resolveMediaUrl } from "../../../utils/mediaUrl";
import { exportStructuredRecordPdf } from "../../../utils/structuredPdfExport";

// ─────────────────────────────────────────────────────────────────
// Helpers — derive MCA / compliance status from existing API fields
// ─────────────────────────────────────────────────────────────────
const normalizeYes = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") return value.trim().toLowerCase() === "yes";
  return false;
};

const normalizeCompanyType = (value) =>
  value?.toString().toLowerCase().replace(/\s+/g, " ").trim() || "";

const nonCinCompanyTypes = new Set([
  "sole proprietorship",
  "partnership firm",
  "limited liability partnership (llp)",
  "limited liability partnership",
  "llp",
  "hindu undivided family (huf)",
  "huf",
  "trust",
  "society",
  "association of persons (aop) / body of individuals (boi)",
  "association of persons",
  "body of individuals",
  "aop",
  "boi",
  "government department / authority",
  "government department",
  "authority",
]);

const cinRequiredCompanyTypes = new Set([
  "private limited company",
  "public limited company",
  "one person company (opc)",
  "one person company",
  "opc",
  "section 8 company (not-for-profit)",
  "section 8 company",
  "government company / psu",
  "government company",
  "psu",
]);

const isCinBlacklisted = (vendor) =>
  normalizeYes(vendor?.isCompanyStrikedOff) ||
  normalizeYes(vendor?.isCompanyUnderStrikeOff) ||
  normalizeYes(vendor?.isCompanyStrikedOffUs248) ||
  vendor?.cin_status === "Mismatch" ||
  normalizeYes(vendor?.isCompanyUnderLiquidation) ||
  normalizeYes(vendor?.isCompanyUnderCirp) ||
  normalizeYes(vendor?.isVanishing);

const getMcaStatus = (vendor) => {
  const companyType = normalizeCompanyType(vendor?.company_type);
  const isNonCinType = nonCinCompanyTypes.has(companyType);
  const isCinRequiredType = cinRequiredCompanyTypes.has(companyType);
  const hasCin = !!(vendor?.company_registration_number || vendor?.corporate_identity_number);
  const cinNotRequired = vendor?.cin_status === "Not Required" || (!hasCin && isNonCinType);

  if (cinNotRequired) return vendor?.company_type || "Not Applicable";
  if (!hasCin && isCinRequiredType) return "PENDING";
  if (
    normalizeYes(vendor?.isCompanyStrikedOff) ||
    normalizeYes(vendor?.isCompanyUnderStrikeOff) ||
    normalizeYes(vendor?.isCompanyStrikedOffUs248) ||
    vendor?.cin_status === "Mismatch"
  )
    return "STRIKE OFF";
  if (normalizeYes(vendor?.isCompanyUnderLiquidation)) return "UNDER LIQUIDATION";
  if (normalizeYes(vendor?.isCompanyUnderCirp)) return "CIRP";
  if (normalizeYes(vendor?.isVanishing)) return "DORMANT";
  if (vendor?.company_registration_number || vendor?.corporate_identity_number) return "ACTIVE";
  return "PENDING";
};

const getComplianceStatus = (vendor) => {
  const gst = vendor?.gst_status;
  const pan = vendor?.pan_status;
  const bank = vendor?.bank_status;
  if (!gst && !pan && !bank) return "N/A";
  if (gst === "Verified" && pan === "Verified" && bank === "Verified")
    return "Compliant";
  return "Non-Compliant";
};

const getRiskScore = (vendor) => {
  let score = 0;
  if (vendor?.gst_status !== "Verified") score += 20;
  if (vendor?.pan_status !== "Verified") score += 20;
  if (vendor?.bank_status !== "Verified") score += 15;
  if (vendor?.cin_status === "Mismatch") score += 25;
  if (vendor?.msme_status === "Mismatch") score += 10;
  if (normalizeYes(vendor?.isCompanyStrikedOff) || normalizeYes(vendor?.isCompanyUnderStrikeOff)) score += 30;
  if (normalizeYes(vendor?.isCompanyUnderLiquidation)) score += 40;
  if (normalizeYes(vendor?.isVanishing) || normalizeYes(vendor?.isShell)) score += 35;
  if (normalizeYes(vendor?.isMlm) || normalizeYes(vendor?.isPep)) score += 20;
  return Math.min(score, 99);
};

const getRiskLevel = (score) => {
  if (score <= 25) return "Low";
  if (score <= 50) return "Medium";
  if (score <= 75) return "High";
  return "Critical";
};

const getRecommendation = (vendor) => {
  const mcaStatus = getMcaStatus(vendor);
  if (mcaStatus === "STRIKE OFF" || mcaStatus === "UNDER LIQUIDATION" || mcaStatus === "CIRP")
    return { primary: "Strike-off", sub: "Block Vendor", color: "red" };
  const score = getRiskScore(vendor);
  if (score > 50)
    return { primary: "High Risk", sub: "Review", color: "orange" };
  if (score > 25)
    return { primary: "Review", sub: "Monitor", color: "orange" };
  return { primary: "Active", sub: "Continue", color: "green" };
};

const getMcaStatusStyle = (status) => {
  switch (status) {
    case "ACTIVE":           return "statusBadge_active";
    case "STRIKE OFF":       return "statusBadge_strikeoff";
    case "DORMANT":          return "statusBadge_dormant";
    case "UNDER LIQUIDATION":return "statusBadge_liquidation";
    default:                 return "statusBadge_pending";
  }
};
const getMcaDotStyle = (status) => {
  switch (status) {
    case "ACTIVE":           return "statusDot_active";
    case "STRIKE OFF":       return "statusDot_strikeoff";
    case "DORMANT":          return "statusDot_dormant";
    case "UNDER LIQUIDATION":return "statusDot_liquidation";
    default:                 return "statusDot_pending";
  }
};

const getRiskCircleStyle = (level) => {
  switch (level) {
    case "Low":      return "riskCircle_low";
    case "Medium":   return "riskCircle_medium";
    case "High":     return "riskCircle_high";
    case "Critical": return "riskCircle_critical";
    default:         return "riskCircle_low";
  }
};
const getRiskLabelStyle = (level) => {
  switch (level) {
    case "Low":      return "riskLabel_low";
    case "Medium":   return "riskLabel_medium";
    case "High":     return "riskLabel_high";
    case "Critical": return "riskLabel_critical";
    default:         return "riskLabel_low";
  }
};

const getCompanyInitials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

const formatCompanyName = (name = "") => {
  const cleaned = String(name || "").replace(/\s+/g, " ").trim();
  if (!cleaned) return "";
  return cleaned
    .toLowerCase()
    .split(" ")
    .map((word) =>
      word
        .split("-")
        .map((part) => (part ? part[0].toUpperCase() + part.slice(1) : ""))
        .join("-")
    )
    .join(" ");
};


const getFirstFilledValue = (source = {}, keys = []) => {
  for (const key of keys) {
    const value = source?.[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return value;
    }
  }
  return "";
};

const getMsmeEnterpriseType = (vendor = {}) =>
  getFirstFilledValue(vendor, [
    "msme_type_of_enterprise",
    "msme_enterprise_type",
    "type_of_enterprise",
    "enterprise_type",
    "enterpriseType",
    "msme_enterprise_category",
  ]);

const formatVendorAddress = (vendor = {}) => {
  const parts = [
    vendor?.company_address,
    vendor?.city,
    vendor?.state,
    vendor?.country,
    vendor?.postal_code,
  ]
    .map((part) => String(part || "").trim())
    .filter(Boolean);

  return parts.length ? parts.join(", ") : "-";
};
const getRiskFlags = (vendor) => {
  const flags = [];
  if (vendor?.gst_status !== "Verified" && vendor?.gst_status)
    flags.push({ label: "GST Issue", color: "riskFlag_orange" });
  if (vendor?.cin_status === "Mismatch")
    flags.push({ label: "CIN Mismatch", color: "riskFlag_red" });
  if (vendor?.msme_status === "Mismatch")
    flags.push({ label: "MSME Mismatch", color: "riskFlag_orange" });
  if (normalizeYes(vendor?.isCompanyStrikedOff))
    flags.push({ label: "Strike-off", color: "riskFlag_red" });
  if (normalizeYes(vendor?.isCompanyUnderStrikeOff))
    flags.push({ label: "Under Strike-off", color: "riskFlag_red" });
  if (normalizeYes(vendor?.isCompanyStrikedOffUs248))
    flags.push({ label: "Strike-off U/S 248", color: "riskFlag_red" });
  if (normalizeYes(vendor?.isCompanyUnderLiquidation))
    flags.push({ label: "Under Liquidation", color: "riskFlag_red" });
  if (normalizeYes(vendor?.isCompanyUnderCirp))
    flags.push({ label: "CIRP", color: "riskFlag_orange" });
  if (normalizeYes(vendor?.isVanishing))
    flags.push({ label: "Dormant/Vanishing", color: "riskFlag_orange" });
  if (normalizeYes(vendor?.isShell))
    flags.push({ label: "Shell Company", color: "riskFlag_red" });
  if (normalizeYes(vendor?.isPep))
    flags.push({ label: "PEP", color: "riskFlag_red" });
  if (normalizeYes(vendor?.isMlm))
    flags.push({ label: "MLM", color: "riskFlag_orange" });
  if (normalizeYes(vendor?.isDomainInvalid))
    flags.push({ label: "Invalid Domain", color: "riskFlag_orange" });
  if (normalizeYes(vendor?.isEmailDisposable))
    flags.push({ label: "Disposable Email", color: "riskFlag_blue" });
  if (vendor?.bank_status === "Verified")
    flags.push({ label: "Bank Verified", color: "riskFlag_green" });
  if (vendor?.pan_status === "Verified")
    flags.push({ label: "PAN Verified", color: "riskFlag_green" });
  if (vendor?.gst_status === "Verified")
    flags.push({ label: "GST Verified", color: "riskFlag_green" });
  return flags;
};

const getVendorOnboardingStatus = (vendor) => {
  const isPan = vendor?.pan_status === "Verified";
  const isGst = vendor?.gst_status === "Verified";
  const isCheque = vendor?.bank_status === "Verified";
  const isCin = !vendor?.cin_status || vendor?.cin_status === "Verified" || vendor?.cin_status === "";
  const isMsme = !vendor?.msme_status || vendor?.msme_status === "Verified" || vendor?.msme_status === "";
  const hasCinMismatch = vendor?.cin_status && vendor?.cin_status !== "Verified" && vendor?.cin_status !== "";
  const hasMsmeMismatch = vendor?.msme_status && vendor?.msme_status !== "Verified" && vendor?.msme_status !== "";

  return isPan && isGst && isCheque && isCin && isMsme && !hasCinMismatch && !hasMsmeMismatch
    ? "Fully Onboarded"
    : "Partially Onboarded";
};

const normalizeVendorDocumentUrl = (value) => resolveMediaUrl(value);

const VENDOR_DOCUMENT_FIELD_CONFIG = [
  { label: "Business Registration Certificate", field: "business_reg_certificate" },
  { label: "PAN Card", field: "pan_card" },
  { label: "One Cancelled Cheque Leaf", field: "one_cancelled_cheque_leaf" },
  { label: "GST Certificate", field: "tax_registration_certificate" },
  { label: "MSME Certificate", field: "msme_certificate" },
  { label: "TDS Certificate", field: "tds_certificate" },
  { label: "CIN Certificate", field: "corporate_identity_certificate" },
];

const getVendorDocumentValue = (vendor = {}, field) => {
  const docs = vendor?.vendor_documents;
  return docs?.[field] || vendor?.[field] || vendor?.admin?.[field] || vendor?.users?.[field] || "";
};

const buildVendorDocumentLinks = (vendor = {}) =>
  VENDOR_DOCUMENT_FIELD_CONFIG.map(({ label, field }) => ({
    label,
    url: normalizeVendorDocumentUrl(getVendorDocumentValue(vendor, field)),
  })).filter((doc) => doc.url);

const buildVendorDocuments = (vendor = {}) =>
  VENDOR_DOCUMENT_FIELD_CONFIG.map(({ label, field }) => ({
    label,
    url: normalizeVendorDocumentUrl(getVendorDocumentValue(vendor, field)),
  }));

const mergeVendorDetailResponse = (rowData = {}, apiData = {}) => {
  const users = apiData.users || {};
  const admin = apiData.admin || {};
  const vendorDocuments = apiData.vendor_documents || {};
  const merged = { ...rowData, ...users, ...admin };

  VENDOR_DOCUMENT_FIELD_CONFIG.forEach(({ field }) => {
    const url = vendorDocuments[field] || admin[field] || users[field];
    if (url) merged[field] = url;
  });

  if (Object.keys(vendorDocuments).length) {
    merged.vendor_documents = vendorDocuments;
  }

  return merged;
};

const formatPdfDate = (value) => {
  if (!value) return "NA";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatPdfCheckValue = (value) => {
  if (value === null || value === undefined || value === "") return "NA";
  if (typeof value === "boolean") return value ? "Yes" : "No";

  const normalized = String(value).trim().toLowerCase();
  if (["yes", "true", "verified", "active", "pass", "passed"].includes(normalized)) return "Yes";
  if (["no", "false", "not verified", "inactive", "fail", "failed"].includes(normalized)) return "No";

  return String(value);
};

const buildRowsFromFields = (source = {}, fields = []) =>
  fields
    .map(({ label, keys = [], format }) => {
      const keyList = Array.isArray(keys) ? keys : [keys];
      const rawValue = keyList.find((key) => {
        const candidate = source?.[key];
        return candidate !== undefined && candidate !== null && candidate !== "";
      });

      if (!rawValue) return null;

      const value = source?.[rawValue];
      const formatted = typeof format === "function" ? format(value, source) : value;
      if (formatted === undefined || formatted === null || formatted === "") return null;

      return [label, formatted];
    })
    .filter(Boolean);

const TDS_BLACKLIST_CHECKS = [
  { label: "Company Struck Off", key: "isCompanyStrikedOff" },
  { label: "Company Under Strike Off", key: "isCompanyUnderStrikeOff" },
  { label: "Company Struck Off U/S 248", key: "isCompanyStrikedOffUs248" },
  { label: "Company Under Liquidation", key: "isCompanyUnderLiquidation" },
  { label: "Company Under CIRP", key: "isCompanyUnderCirp" },
  { label: "Vanishing Company", key: "isVanishing" },
  { label: "Shell Company", key: "isShell" },
  { label: "Politically Exposed Person", key: "isPep" },
  { label: "Multi Level Marketing", key: "isMlm" },
  { label: "Invalid Domain", key: "isDomainInvalid" },
  { label: "Disposable Email", key: "isEmailDisposable" },
];

const buildVendorPdfSections = (vendor = {}) => {
  const businessRows = buildRowsFromFields(vendor, [
    { label: "Company Name", keys: ["company_name"] },
    { label: "Company Type", keys: ["company_type"] },
    { label: "Company Website", keys: ["company_website"] },
    {
      label: "Company Identification Number",
      keys: ["company_registration_number", "corporate_identity_number"],
    },
    { label: "Supplier ID", keys: ["vendor_code"] },
    { label: "Created Date", keys: ["created_on"], format: formatPdfDate },
  ]);

  const proprietorContactRows = buildRowsFromFields(vendor, [
    { label: "First Name", keys: ["first_name"] },
    { label: "Last Name", keys: ["last_name"] },
    { label: "Designation", keys: ["designation"] },
    { label: "Official Mobile Number", keys: ["official_mobile_number", "mobile_number"] },
    { label: "Official Email Address", keys: ["official_email_address"] },
  ]);

  const representativeContactRows = buildRowsFromFields(vendor, [
    { label: "First Name", keys: ["rep_first_name"] },
    { label: "Last Name", keys: ["rep_last_name"] },
    { label: "Designation", keys: ["rep_designation"] },
    { label: "Official Mobile Number", keys: ["rep_official_mobile_number"] },
    { label: "Official Email Address", keys: ["rep_official_email_address"] },
  ]);

  const financeRepresentativeRows = buildRowsFromFields(vendor, [
    { label: "First Name", keys: ["financerep_first_name"] },
    { label: "Last Name", keys: ["financerep_last_name"] },
    { label: "Designation", keys: ["financerep_designation"] },
    { label: "Official Mobile Number", keys: ["financerep_mobile_num"] },
    { label: "Official Email Address", keys: ["financerep_email"] },
  ]);

  const gstRows = buildRowsFromFields(vendor, [
    { label: "GST Number", keys: ["tax_identification_number"] },
    { label: "GST Status", keys: ["gst_status"] },
    { label: "Trade Name", keys: ["gst_trade_name"] },
    { label: "Legal Name", keys: ["pan_name"] },
    { label: "GST Place of Business", keys: ["gst_place_of_business"] },
    { label: "Nature of Business", keys: ["gst_nature_of_business"] },
    { label: "GST Registration Type", keys: ["gst_type_of_registration"] },
  ]);

  const panRows = buildRowsFromFields(vendor, [
    { label: "PAN Number", keys: ["pan_number"] },
    { label: "PAN Name", keys: ["pan_name"] },
    { label: "PAN Status", keys: ["pan_status"] },
  ]);

  const msmeRows = buildRowsFromFields(vendor, [
    { label: "MSME Registration Number", keys: ["msme_registration_number"] },
    { label: "MSME Status", keys: ["msme_status"] },
  ]);

  const bankRows = buildRowsFromFields(vendor, [
    { label: "Bank Name", keys: ["bank_name"] },
    { label: "Account Holder Name", keys: ["account_holder_name"] },
    { label: "Account Number", keys: ["account_number"] },
    { label: "Account Type", keys: ["account_type"] },
    { label: "Branch Code", keys: ["branch_code"] },
    { label: "IFSC/SWIFT/IBAN Code", keys: ["bank_identification_code"] },
    { label: "Branch Address", keys: ["branch_address"] },
    { label: "Bank Status", keys: ["bank_status"] },
  ]);

  const tdsRows = TDS_BLACKLIST_CHECKS.map(({ label, key }) => [label, formatPdfCheckValue(vendor?.[key])]);
 
 

  const documentRows = buildVendorDocumentLinks(vendor);
  const documentStatusRows = documentRows.map((doc) => [doc.label, "Uploaded"]);
  const documentLinkRows = documentRows.map((doc) => [doc.label, doc.url]);
  const tdsFinancialRows = buildRowsFromFields(vendor?.tds_details || {}, [

  { label: "Total Expenditure", keys: ["totExp"] },
  { label: "Net Profit Margin", keys: ["netProfitMargin"] },
  { label: "EBITDA Margin", keys: ["ebitdaMargin"] },
  { label: "Net Sales Growth", keys: ["netSalesGrowth"] },
  { label: "Net Worth Growth", keys: ["netWorthGrowth"] },
]);

  return [
    { title: "GST Details", icon: "G", rows: gstRows },
    { title: "PAN Details", icon: "P", rows: panRows },
    { title: "Business Info", icon: "B", rows: businessRows },
    { title: "MSME Details", icon: "M", rows: msmeRows },
    { title: "Bank Details", icon: "A", rows: bankRows },
    { title: "Proprietor Contact Details", icon: "C", rows: proprietorContactRows },
    { title: "Representative Contact Details", icon: "R", rows: representativeContactRows },
    { title: "Finance Representative Contact Details", icon: "F", rows: financeRepresentativeRows },
    { title: "Blacklist Checks", icon: "B", rows: tdsRows },
   { title: "TDS Corporate Financials", icon: "T", rows: tdsFinancialRows },

    { title: "Documents", icon: "D", rows: documentStatusRows },
    { title: "Document Link", icon: "L", rows: documentLinkRows },
  ].filter((section) => Array.isArray(section.rows) && section.rows.length > 0);
};

// ─────────────────────────────────────────────────────────────────

const BuyerVendorsTab = () => {
  // ── ALL EXISTING STATE — untouched ───────────────────────────
  const [vendorMain, setVendorMain] = useState(true);
  const [openViewVendor, setOpenViewVendor] = useState(false);
  const [iseditable, setiseditable] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const Datas = useSelector((state) => state.loginData.value);

  const [tab1, setTab1] = useState(false);
  const [tab2, setTab2] = useState(false);
  const [tab3, setTab3] = useState(false);
  const [tab4, setTab4] = useState(false);
  const [tab5, setTab5] = useState(true);
  const [tab6, setTab6] = useState(false);
  const [tab7, setTab7] = useState(false);
  const [tab8, setTab8] = useState(false);

  const tab1Click = () => { setTab1(true);  setTab2(false); setTab3(false); setTab4(false); setTab5(false); setTab6(false); setTab7(false); setTab8(false); };
  const tab2Click = () => { setTab1(false); setTab2(true);  setTab3(false); setTab4(false); setTab5(false); setTab6(false); setTab7(false); setTab8(false); };
  const tab3Click = () => { setTab1(false); setTab2(false); setTab3(true);  setTab4(false); setTab5(false); setTab6(false); setTab7(false); setTab8(false); };
  const tab4Click = () => { setTab1(false); setTab2(false); setTab3(false); setTab4(true);  setTab5(false); setTab6(false); setTab7(false); setTab8(false); };
  const tab5Click = () => { setTab1(false); setTab2(false); setTab3(false); setTab4(false); setTab5(true);  setTab6(false); setTab7(false); setTab8(false); };
  const tab6Click = () => { setTab1(false); setTab2(false); setTab3(false); setTab4(false); setTab5(false); setTab6(true);  setTab7(false); setTab8(false); };
  const tab7Click = () => { setTab1(false); setTab2(false); setTab3(false); setTab4(false); setTab5(false); setTab6(false); setTab7(true);  setTab8(false); };
  const tab8Click = () => { setTab1(false); setTab2(false); setTab3(false); setTab4(false); setTab5(false); setTab6(false); setTab7(false); setTab8(true);  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "NA";
    const date = new Date(isoDate);
    return date.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true });
  };

  const dispatch = useDispatch();
  const data = useSelector((state) => state.loginData.value);
  const vendorsData = useSelector((state) => state.vendorsData.value);

  const [popupHeroText, setPopupHeroText]   = useState("");
  const [popupImage, setPopupImage]         = useState(successPopupImg);
  const [searchQuery, setSearchQuery]       = useState("");
  const [uniqueData, setUniqueData]         = useState();
  const [uniqueLocalData, setUniqueLocalData] = useState();
  const [uniqueDataID, setUniqueDataID]     = useState("");
  const [vendorUserToken, setVendorUserToken] = useState("");
  const [auth_token, setAuthToken]          = useState(data?.auth_token);
  const [organization_token, setOrganizationToken] = useState(data?.organization_token);
  const [org_token, setOrg_token]           = useState(data?.user?.token);
  const [popupMessage, setPopupMessage]     = useState("");
  const [currentPage, setCurrentPage]       = useState(1);
  const itemsPerPage = paginationData?.current_page_count;
  const totalItems   = paginationData?.page_count;
  const vendorContactRole = uniqueLocalData?.role !== "vendor contact";
  const [tableProps, setTableProps]         = useState({ isLoading: false, errorMessage: "" });
  const [primaryBtnError, setPrimaryBtnError] = useState({ error: false, errorMsg: "" });
  const [loadingState, setLoadingState]     = useState(false);
  const [loadingStateDwnload, setLoadingStateDwnload] = useState(false);
  const [sortingColumnName, setSortingColumnName] = useState(null);
  const [sortingOrder, setSortingOrder]     = useState(null);
  const order = sortingOrder === null || sortingOrder === "asc" ? "desc" : "asc";
  const [selectedDocs, setSelectedDocs]     = useState([]);
  const [vendorPdfLoadingToken, setVendorPdfLoadingToken] = useState("");
  const [vendorSummary, setVendorSummary]   = useState(null);
  const [vendorSummaryLoading, setVendorSummaryLoading] = useState(false);
  const tooltipSlotProps = {
    tooltip: { sx: { fontSize: "1.35rem", padding: "8px 12px" } },
  };

  // ── NEW UI state ──────────────────────────────────────────────
  const [activeQuickFilter, setActiveQuickFilter] = useState("All");
  const [selectedVendorDetail, setSelectedVendorDetail] = useState(null);
  const [detailTab, setDetailTab] = useState("Overview");

  // ── Vendor limit guard ────────────────────────────────────────
  const vendorPlanLimit = Datas?.vendor_count ?? 0;

  const getTotalVendors = () =>
    paginationData?.total_records ?? vendorsData?.length ?? 0;

  const atVendorLimit = vendorPlanLimit > 0 && getTotalVendors() >= vendorPlanLimit;

  const guardLimitAndShow = () => {
    if (!atVendorLimit) return false;
    setPopupHeroText("Supplier limit reached");
    setPopupMessage(`Your account can have up to ${vendorPlanLimit} vendors. Current vendors: ${getTotalVendors()}.`);
    setPopupImage(deletePopupImg);
    setOpenS(true);
    return true;
  };

  const getOnboardingStatus = useCallback((vendor) => {
    const isPan   = vendor?.pan_status  === "Verified";
    const isGst   = vendor?.gst_status  === "Verified";
    const isCheque = vendor?.bank_status === "Verified";
    const isCin   = !vendor?.cin_status  || vendor?.cin_status  === "Verified" || vendor?.cin_status  === "";
    const isMsme  = !vendor?.msme_status || vendor?.msme_status === "Verified" || vendor?.msme_status === "";
    const hasCinMismatch  = vendor?.cin_status  && vendor?.cin_status  === "Mismatch";
    const hasMsmeMismatch = vendor?.msme_status && vendor?.msme_status === "Mismatch";
    if (isPan && isGst && isCheque && !hasCinMismatch && !hasMsmeMismatch) return "Fully Onboarded";
    return "Partially Onboarded";
  }, []);

  // ── KPI values ────────────────────────────────────────────────
  const kpiSource = vendorsData ?? [];
  const kpiTotal = kpiSource.length;
  const totalVendors = Number(vendorSummary?.total_number_of_vendors) || 0;
  const summaryVal = (key) => Number(vendorSummary?.[key]) || 0;
  const fullyOnboarded = summaryVal("fully_onboarded_vendors_count");
  const partialCount = summaryVal("partially_onboarded_vendors_count");
  const activeCount = summaryVal("active_vendors_count");
  const gstCompliant = summaryVal("complaint_count");
  const blacklistedCount = summaryVal("blacklisted_count");
  const nonMsmeCount = summaryVal("non_msme_count");
  const nonCinCount = summaryVal("non_cin_count");
  const percentOf = (value, total) =>
    total ? `${((value / total) * 100).toFixed(1)}%` : "0%";
  const kpiLoading = vendorSummaryLoading;
  const kpiCards = [
    {
      label: "Total Vendors",
      value: totalVendors,
      badge: "100%",
      sub: "Across all statuses",
      hint: "Total vendors across the organization",
      color: "blue",
      icon: <GroupsOutlined className={classes.kpiIcon} />,
      scope: "All",
    },
    {
      label: "Fully Onboarded",
      value: fullyOnboarded,
      badge: percentOf(fullyOnboarded, totalVendors),
      sub: "All checks completed",
      hint: "PAN, GST, Bank verified with no CIN/MSME mismatch",
      color: "green",
      icon: <CheckCircleOutline className={classes.kpiIcon} />,
      scope: "Page",
    },
    {
      label: "Partially Onboarded",
      value: partialCount,
      badge: percentOf(partialCount, totalVendors),
      sub: "Pending verification",
      hint: "Any missing/failed verification",
      color: "orange",
      icon: <PendingActionsOutlined className={classes.kpiIcon} />,
      scope: "Page",
    },
    {
      label: "Active",
      value: activeCount,
      badge: percentOf(activeCount, totalVendors),
      sub: "MCA active vendors",
      hint: "Derived MCA status = ACTIVE",
      color: "green",
      icon: <VerifiedUserOutlined className={classes.kpiIcon} />,
      scope: "Page",
    },
    {
      label: "Compliance",
      value: gstCompliant,
      badge: percentOf(gstCompliant, totalVendors),
      sub: "GST verified vendors",
      hint: "GST status is Verified",
      color: "blue",
      icon: <FactCheckOutlined className={classes.kpiIcon} />,
      scope: "Page",
    },
    {
      label: "Non-CIN",
      value: nonCinCount,
      badge: percentOf(nonCinCount, totalVendors),
      sub: "CIN not required types",
      hint: "Company type does not require CIN",
      color: "orange",
      icon: <PendingActionsOutlined className={classes.kpiIcon} />,
      scope: "Page",
    },
    {
      label: "Non-MSME",
      value: nonMsmeCount,
      badge: percentOf(nonMsmeCount, totalVendors),
      sub: "No MSME registration",
      hint: "MSME registration missing or not verified",
      color: "orange",
      icon: <PendingActionsOutlined className={classes.kpiIcon} />,
      scope: "Page",
    },
    {
      label: "Blacklisted",
      value: blacklistedCount,
      badge: percentOf(blacklistedCount, totalVendors),
      sub: "CIN/MCA blacklist flags",
      hint: "Strike-off/blacklist flags detected",
      color: "red",
      icon: <Visibility className={classes.kpiIcon} />,
      scope: "Page",
    },
  ];

  const quickFilters = [
    { label: "Active",           dot: "#22c55e" },
    { label: "Strike-off",       dot: "#ef4444" },
    { label: "High Risk",        dot: "#f97316" },
    { label: "Dormant",          dot: "#94a3b8" },
    { label: "Under Liquidation",dot: "#8b5cf6" },
  ];

  // ── Offline / data hooks (all untouched) ──────────────────────
  const vendorSortKeyForApi =
    sortingColumnName === "created_date" ? "created_date" : "";
  const vendorSortOrderForApi = vendorSortKeyForApi
    ? sortingOrder === "desc"
      ? "descending"
      : sortingOrder === "asc"
        ? "ascending"
        : ""
    : "";

  const { datas, pagination, loading, refetch } = useOfflineVendorMaster(
    auth_token,
    org_token,
    searchQuery,
    pageNumber,
    10,
    vendorSortKeyForApi,
    vendorSortOrderForApi,
  );

  const toggleCreatedDateSort = () => {
    setPageNumber(1);
    if (sortingColumnName !== "created_date") {
      setSortingColumnName("created_date");
      setSortingOrder("asc");
      return;
    }
    setSortingOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  useEffect(() => {
    dispatch(setVendorsData(datas));
    setPaginationData(pagination);
    setTableProps({ isLoading: loading, errorMessage: "" });
  }, [datas, pagination, loading]);

  const fetchVendorSummaryCounts = useCallback(async () => {
    if (!auth_token || !org_token) return;
    setVendorSummaryLoading(true);
    try {
      const response = await axios.post(
        API_ENDPOINT.vendor_master_summary_counts,
        { org_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );
      setVendorSummary(response?.data || null);
    } catch (error) {
      console.error("Failed to fetch vendor summary counts", error);
    } finally {
      setVendorSummaryLoading(false);
    }
  }, [auth_token, org_token]);

  useEffect(() => {
    fetchVendorSummaryCounts();
  }, [fetchVendorSummaryCounts]);


  // ── All existing API calls, handlers etc. (UNTOUCHED) ─────────
  const GetAllData = async () => {
    setTableProps((prev) => ({ ...prev, isLoading: true }));
    try {
      const response = await axios.post(
        API_ENDPOINT.vendor_master_full_view,
        { org_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );
      const results = response?.data?.results || [];
      let formattedData = results.map((item) => {
        const users = item.users || {};
        const admin = item.admin || {};
        const vendorDocuments = item.vendor_documents || {};
        const merged = { ...users, ...admin, users, tds_details: item.tds_details || {} };

        VENDOR_DOCUMENT_FIELD_CONFIG.forEach(({ field }) => {
          const url = vendorDocuments[field] || admin[field] || users[field];
          if (url) merged[field] = url;
        });

        if (Object.keys(vendorDocuments).length) {
          merged.vendor_documents = vendorDocuments;
        }

        return merged;
      });
      if (sortingColumnName) {
        formattedData.sort((a, b) => {
          const valA = a[sortingColumnName] || "";
          const valB = b[sortingColumnName] || "";
          return sortingOrder === "desc" ? (valA > valB ? -1 : 1) : (valA > valB ? 1 : -1);
        });
      }
      const pageSize = 10;
      const startIndex = (pageNumber - 1) * pageSize;
      const paginatedData = formattedData.slice(startIndex, startIndex + pageSize);
      dispatch(setVendorsData(paginatedData));
      setPaginationData({ total_records: formattedData.length, page_count: Math.ceil(formattedData.length / pageSize), current_page_count: paginatedData.length });
      setTableProps({ isLoading: false, errorMessage: "" });
    } catch (error) {
      setTableProps({ isLoading: false, errorMessage: "Failed to fetch vendor data" });
    }
  };

  const reverifyVendor = async (vendorEmail) => {
    try {
      await axios.post(
        API_ENDPOINT.trigger_status_email,
        { official_email_address: vendorEmail },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );
      setPopupHeroText("Reverify request sent!");
      setPopupMessage("Supplier verification has been re-initiated.");
      setPopupImage(successPopupImg);
      setOpenS(true);
      refetch();
    } catch (error) {
      console.error(error);
    }
  };

  const headings = [
    { label: "Company Name",      field: "company_name", additional_data: "full_profile" },
    { label: "Contact Person",    field: "first_name" },
    { label: "Role",              field: "role" },
    { label: "Contact Number",    field: "official_mobile_number" },
    { label: "Invite Email",      field: "invite_email_address" },
    { label: "Registered Email",  field: "official_email_address" },
    { label: "Supplier ID",       field: "vendor_code" },
    { label: "Created Date",      field: "created_on" },
    { label: "Onboarding Status", field: "onboarding_status", customCell: true },
    { label: "Reverify",          field: "reverify_action",   customCell: true },
  ];

  const deleteVendor = async () => {
    setLoadingState(true);
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.delete_vendor}`,
      data: { buyer_token: data?.user?.token, vendor_token: uniqueDataID },
      headers: { Authorization: `Bearer ${auth_token}` },
    })
      .then((res) => {
        setLoadingState(false);
        refetch();
        handleCloseDltConfirmation();
        setPopupHeroText("Supplier has been Deleted!");
        setPopupMessage(res?.data?.response);
      })
      .catch((err) => {
        setLoadingState(false);
        setPopupHeroText("Something went wrong!");
        setPopupMessage(err?.response?.data?.response);
      });
  };

  const [openDlt, setOpenDlt] = useState(false);
  const handleOpenDlt = () => setOpenDlt(true);
  const handleCloseDlt = () => setOpenDlt(false);

  const [openDltConfirmation, setOpenDltConfirmation] = useState(false);
  const handleOpenDltConfirmation = (deletion_id, rowData) => {
    setOpenDltConfirmation(true);
    let uniqueRowData = getUniqueData(vendorsData, "token", deletion_id);
    setPopupHeroText(`Are you sure want to delete "${uniqueRowData?.full_name}"?`);
    setUniqueData(uniqueRowData);
    setPopupMessage("Heads up! deletion can't be undone.");
    setUniqueDataID(rowData?.token);
  };
  const handleCloseDltConfirmation = () => setOpenDltConfirmation(false);

  const handleDeleteVendor = () => {
    handleOpenDlt();
    deleteVendor();
    handleCloseDltConfirmation();
  };

  const viewVendorClick = async (unique_id, rowData) => {
    setVendorMain(false);
    setOpenViewVendor(true);
    const selectedVendor = vendorsData.find((v) => v.token === rowData.token) || rowData;
    setUniqueData(selectedVendor);
    setUniqueLocalData(selectedVendor);
    setVendorUserToken(selectedVendor?.user_token);

    try {
      setLoadingState(true);
      const response = await axios.post(
        `${API_ENDPOINT.get_individual_vendor}vendor_token=${rowData.token}`,
        {},
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );
      const merged = mergeVendorDetailResponse(selectedVendor, response?.data || {});
      setUniqueData(merged);
      setUniqueLocalData(merged);
      setVendorUserToken(merged?.user_token);
    } catch (error) {
      console.error("Failed to fetch vendor details", error);
    } finally {
      setLoadingState(false);
    }
  };

  const [v_token, setv_token] = useState();

  const editVendorClick = (unique_user_id, rowData) => {
    setVendorsAction({ addVendor: false, updateVendor: true, addBulkItems: false });
    setVendorMain(true);
    setOpen(true);
    setUniqueDataID(rowData?.token);
    const selectedVendor = vendorsData.find((v) => v.token === rowData.token);
    setUniqueData(selectedVendor);
    updateInputs(selectedVendor);
  };

  const [open, setOpen] = useState(false);
  const [primaryBtnLabel, setPrimaryBtnLabel] = useState();
  const [vendorsAction, setVendorsAction] = useState({ addVendor: false, updateVendor: false, addBulkItems: false });

  useEffect(() => {
    setPrimaryBtnLabel(
      vendorsAction.addVendor ? "Add" :
      vendorsAction.updateVendor ? "Update" :
      vendorsAction.addBulkItems ? "Add Bulk Vendors" : ""
    );
  }, [vendorsAction]);

  const updateInputs = (data) => {
    if (!data?.vendor_code || data?.vendor_code.length === 0) setiseditable(true);
    else setiseditable(false);
    setPersonName((prev) => ({ ...prev, value: data?.full_name || "" }));
    setCompanyName((prev) => ({ ...prev, value: data?.company_name || "" }));
    setVendorCode((prev) => ({ ...prev, value: data?.vendor_code || "" }));
    setVendorRegisteredEmail((prev) => ({ ...prev, value: data?.official_email_address || "" }));
  };

  const handleOpen = () => {
    if (guardLimitAndShow()) return;
    setOpen(true);
    setVendorsAction({ addVendor: true, updateVendor: false, addBulkItems: false });
  };
  const handleClose = () => { setOpen(false); resetForm(); };

  const [openS, setOpenS] = useState(false);
  const handleOpenS  = () => setOpenS(true);
  const handleCloseS = () => { setOpenS(false); resetForm(); };

  const [CompanyName, setCompanyName]                   = useState({ value: "", errorMsg: "", isValid: true });
  const [companyList, setCompanyList]                   = useState([]);
  const [VendorRegisteredEmail, setVendorRegisteredEmail] = useState({ value: "", errorMsg: "", isValid: true });
  const [PersonName, setPersonName]                     = useState({ value: "", errorMsg: "", isValid: true });
  const [VendorCode, setVendorCode]                     = useState({ value: "", errorMsg: "", isValid: true });
  const [csvFile, setCsvFile]                           = useState({ value: "", isValid: true });

  const resetForm = () => {
    setVendorRegisteredEmail({ value: "", isValid: true });
    setCompanyName({ value: "", isValid: true });
    setPersonName({ value: "", isValid: true });
    setCsvFile({ value: "", isValid: true });
    setVendorCode({ value: "", isValid: true });
    setPrimaryBtnError({ error: false, errorMsg: "" });
  };

  const regexForAlphabets    = /[^a-zA-Z\s]/g;
  const regexForAlphaNumeric = /[^a-zA-Z0-9\s]+/g;
  const regexForNumber       = /[^\d\s]/g;

  const validateForm = (query) => {
    const isEmailValid  = validateEmail(VendorRegisteredEmail.value);
    const isCompanyName = emptyCheck(CompanyName.value);
    const isPersonName  = emptyCheck(PersonName.value);
    const isCsvFile     = validateFile(csvFile.value, false, ["csv", "xlsx"], 5).isValid;
    setVendorRegisteredEmail((prev) => ({ ...prev, isValid: isEmailValid }));
    setCompanyName((prev) => ({ ...prev, isValid: isCompanyName }));
    setPersonName((prev) => ({ ...prev, isValid: isPersonName }));
    setCsvFile((prev) => ({ ...prev, isValid: isCsvFile }));
    return query === "bulkData" ? isCsvFile : isEmailValid && isCompanyName && isPersonName;
  };

  let abortController = new AbortController();

  const getCompanyList = async (searchValue) => {
    try {
      abortController.abort();
      const newAbortController = new AbortController();
      abortController = newAbortController;
      const formData = new FormData();
      formData.append("buyer_token", org_token);
      formData.append("search", searchValue);
      const response = await axios({ method: "POST", url: `${API_ENDPOINT.getCompanyList}`, data: formData, headers: { Authorization: `Bearer ${auth_token}` }, signal: abortController.signal });
      setCompanyList(response?.data?.response?.map((e) => e?.company_name));
    } catch (error) {
      if (error.name !== "AbortError") console.log(error);
    }
  };

  const addVendor = async () => {
    await axios({ method: "POST", url: `${API_ENDPOINT.add_vendor}`, data: { company_name: CompanyName.value, person_name: PersonName.value, company_official_email: VendorRegisteredEmail.value, buyer_token: org_token }, headers: { Authorization: `Bearer ${auth_token}` } })
      .then((res) => { setPopupHeroText(res?.data?.response); setPopupMessage(res?.data?.response.includes("invite") ? "Looks like the vendor doesn't exist, so we sent an invite mail to onboard them." : "Supplier has been added successfully!"); setPopupImage(successPopupImg); handleOpenS(); handleClose(); resetForm(); setLoadingState(false); refetch(); setPrimaryBtnError({ error: false, errorMsg: "" }); })
      .catch((err) => { console.log(err); setLoadingState(false); setPrimaryBtnError({ error: true, errorMsg: Object.values(err?.response?.data)[0] }); });
  };

  const updateVendor = async () => {
    axios({ url: `${API_ENDPOINT.update_vendor}${uniqueDataID}`, method: "POST", data: { vendor_token: uniqueDataID, company_name: CompanyName.value, first_name: PersonName.value, company_official_email: VendorRegisteredEmail.value, buyer_token: org_token, vendor_code: VendorCode.value }, headers: { Authorization: `Bearer ${auth_token}` } })
      .then((res) => { setLoadingState(false); refetch(); setPopupHeroText("Supplier Updated!"); setPopupMessage(res?.data?.response); setPopupImage(successPopupImg); handleOpenS(); handleClose(); resetForm(); })
      .catch((err) => { console.log(err); setLoadingState(false); setPrimaryBtnError({ error: true, errorMsg: Object.values(err?.response?.data)[0] }); });
  };

  const addBulkItems = async () => {
    setLoadingState(true);
    const formData = new FormData();
    formData.append("org_token", org_token);
    formData.append("csv_file", csvFile.value);
    await axios({ url: `${API_ENDPOINT.vendor_csv_upload}`, method: "POST", data: formData, headers: { Accept: "application/json", Authorization: `Bearer ${auth_token}` } })
      .then((res) => { setLoadingState(false); refetch(); setPopupHeroText("Vendors Added!"); setPopupMessage(res?.data?.response); setPopupImage(successPopupImg); handleOpenS(); handleClose(); resetForm(); })
      .catch((err) => { setLoadingState(false); setPrimaryBtnError({ error: true, errorMsg: (typeof err?.response?.data?.response !== "object" && err?.response?.data?.response) || "Something went wrong! please check the file values & try again." }); });
  };

  const handleSubmit = async () => {
    const validation = vendorsAction.addBulkItems ? validateForm("bulkData") : validateForm();
    if (validation) {
      if (vendorsAction.addVendor) { setLoadingState(true); if (guardLimitAndShow()) { setLoadingState(false); return; } addVendor(); }
      else if (vendorsAction.updateVendor) { setLoadingState(true); updateVendor(); }
      else if (vendorsAction.addBulkItems) { setLoadingState(true); if (guardLimitAndShow()) { setLoadingState(false); return; } addBulkItems(); }
    } else {
      setPrimaryBtnError({ error: true, errorMsg: "Please fill out all fields" });
    }
  };

  const vendorsTabHeading = (
    <HeaderTitle
      titleText={vendorsAction.addVendor ? "Add Suppliers" : vendorsAction.updateVendor ? "Update Vendors" : vendorsAction.addBulkItems ? "Upload Bulk Vendors" : ""}
      customclass={classes.popupHeading}
    />
  );

  const vendorsTabInputs = [
    (vendorsAction.addVendor || vendorsAction.updateVendor) && (
      <DFreeSoloInput
        label="Company Name"
        value={CompanyName.value}
        options={companyList}
        onChange={(value) => { setCompanyName({ value, isValid: emptyCheck(value) }); if (value?.length > 2) getCompanyList(value); else setCompanyList([]); }}
        error={!CompanyName.isValid}
        errorMsg={"Company name is required"}
        size={"100%"}
      />
    ),
    (vendorsAction.addVendor || vendorsAction.updateVendor) && (
      <div className={classes.fields}>
        <DTextInput label="Person Name" maxLength={250} type="text" value={PersonName.value} onChange={(e) => { let val = e?.target?.value?.replace(regexForAlphabets, ""); setPersonName({ value: val, isValid: emptyCheck(e?.target?.value) }); }} error={!PersonName.isValid} errorMsg={"Person name is required"} size={"24rem"} customClassName={classes.addVendorPopupInput} />
        <DTextInput label={"Email"} value={VendorRegisteredEmail.value} onChange={(e) => { let val = e.target.value; setVendorRegisteredEmail({ value: val, isValid: validateEmail(val) }); }} error={!VendorRegisteredEmail.isValid} errorMsg={!emptyCheck(VendorRegisteredEmail.value) ? "Email is required" : !VendorRegisteredEmail.isValid ? "Invalid email format" : ""} customClassName={classes.addVendorPopupInput} size={"24rem"} />
      </div>
    ),
    vendorsAction.addBulkItems && (
      <div className={classes.input_container}>
        <DefaultLabel label={"Upload CSV file"} />
        <DFileUpload fileTypes={".xlsx,.csv"} customFileTypeText={"(Supported format CSV)"} onFileUpload={(file) => { let isValidFile = validateFile(file, false, ["csv", "xlsx"], 5).isValid; setCsvFile({ value: file, isValid: isValidFile }); }} error={!csvFile.isValid} errorMsg={validateFile(csvFile.value, false, ["csv", "xlsx"], 5, "CSV file").errorMessage} size={"100%"} />
        <p className={classes.linkBtn} onClick={() => saveAs(sampleCSV, "Sample CSV")}>Sample CSV</p>
      </div>
    ),
  ];

  const popupActions = [
    <DButtonOutlined key="cancel" label={"Cancel"} onClick={handleClose} btnWidth={"17rem"} btnHeight={"4rem"} buyerBtn={true} />,
    <DButton key="submit" label={primaryBtnLabel} loadingState={loadingState} btnWidth={"17rem"} btnHeight={"4rem"} buyerBtn={true} error={primaryBtnError.error} errorMsg={primaryBtnError.errorMsg} onClick={handleSubmit} />,
  ];

  const handleOpenAddBulkItem = () => {
    if (guardLimitAndShow()) return;
    setOpen(true);
    resetForm();
    setVendorsAction({ addVendor: false, updateVendor: false, addBulkItems: true });
  };

  // ── Detail view data (all untouched) ─────────────────────────
  const formatBlacklistFlag = (value) => {
    if (value === true) return "Yes";
    if (value === false) return "No";
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "yes" || normalized === "true") return "Yes";
      if (normalized === "no" || normalized === "false") return "No";
    }
    if (typeof value === "number") {
      if (value === 1) return "Yes";
      if (value === 0) return "No";
    }
    return "-";
  };

  const formatTdsValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return String(value);
  };

  // Some APIs return vendor payload as `{ users: {...}, tds_details: {...} }`.
  // Normalize here so the UI works for both shapes without changing the flow.
  const vendorProfile = uniqueData?.users || uniqueData || {};

  const business_info = [
    { label: "Company Name",                  value: vendorProfile?.company_name || "-" },
    { label: "Company Type",                  value: vendorProfile?.company_type || "-" },
    { label: "Company Website",               value: vendorProfile?.company_website || "-" },
    { label: "Company Identification Number", value: vendorProfile?.company_registration_number || vendorProfile?.corporate_identity_number || "-" },
  ];
  const address = [
    { label: "Registered Address", value: formatVendorAddress(vendorProfile) },
    { label: "City",         value: vendorProfile?.city || "-" },
    { label: "State",        value: vendorProfile?.state || "-" },
    { label: "Country",      value: vendorProfile?.country || "-" },
    { label: "Postal Code",  value: vendorProfile?.postal_code || "-" },
    { label: "Working Days", value: vendorProfile?.working_days || "-" },
    { label: "Working Hours",value: vendorProfile?.working_hours || "-" },
  ];
  const contact_info = [
    { label: "Phone Number",   value: vendorProfile?.company_phone_number || "-" },
    { label: "Fax Number",     value: vendorProfile?.company_fax_number || "-" },
    { label: "Official Email", value: vendorProfile?.company_official_email || "-" },
  ];
  const vendor_onboarding_blacklist = [
    { label: "Company Striked Off",              value: formatBlacklistFlag(vendorProfile?.isCompanyStrikedOff) },
    { label: "Company Under CIRP",               value: formatBlacklistFlag(vendorProfile?.isCompanyUnderCirp) },
    { label: "Company Under Liquidation",        value: formatBlacklistFlag(vendorProfile?.isCompanyUnderLiquidation) },
    { label: "Vanishing Company",                value: formatBlacklistFlag(vendorProfile?.isVanishing) },
    { label: "Shell Company",                    value: formatBlacklistFlag(vendorProfile?.isShell) },
    { label: "Suspended at Stock Exchange",      value: formatBlacklistFlag(vendorProfile?.isSuspendedAtStockExchange) },
    { label: "Company Under Strike Off",         value: formatBlacklistFlag(vendorProfile?.isCompanyUnderStrikeOff) },
    { label: "MCA Company Defaulter",            value: formatBlacklistFlag(vendorProfile?.isMcaCompanyDefaulter) },
    { label: "MLM",                              value: formatBlacklistFlag(vendorProfile?.isMlm) },
    { label: "PEP",                              value: formatBlacklistFlag(vendorProfile?.isPep) },
    { label: "LLP Striked Off (Rule 37)",        value: formatBlacklistFlag(vendorProfile?.isLlpStrikedOffUnderRule37) },
    { label: "Company Striked Off (U/S 248)",    value: formatBlacklistFlag(vendorProfile?.isCompanyStrikedOffUs248) },
    { label: "Former PEP",                       value: formatBlacklistFlag(vendorProfile?.isFormerPep) },
    { label: "Email Disposable",                 value: formatBlacklistFlag(vendorProfile?.isEmailDisposable) },
    { label: "Domain Invalid",                   value: formatBlacklistFlag(vendorProfile?.isDomainInvalid) },
    { label: "Company Active Non-Compliant",     value: formatBlacklistFlag(vendorProfile?.isCompanyActiveNonCompliant) },
    { label: "Not Filed 5 (INV)",                value: formatBlacklistFlag(vendorProfile?.isNotFiled5inv) },
  ];
  const isCinCompany = cinRequiredCompanyTypes.has(
    normalizeCompanyType(vendorProfile?.company_type)
  );
  const tdsSource =
    uniqueData?.tds_details || vendorProfile?.tds_details || uniqueData?.tdsDetails || vendorProfile?.tdsDetails || {};
  const tdsFinancials = [
    { label: "Total Expenses",    value: formatTdsValue(tdsSource?.totExp) },
    { label: "Net Profit Margin", value: formatTdsValue(tdsSource?.netProfitMargin) },
    { label: "EBITDA Margin",     value: formatTdsValue(tdsSource?.ebitdaMargin) },
    { label: "Net Sales Growth",  value: formatTdsValue(tdsSource?.netSalesGrowth) },
    { label: "Net Worth Growth",  value: formatTdsValue(tdsSource?.netWorthGrowth) },
  ];
  const hasTdsFinancials = tdsFinancials.some((item) => item.value !== "-");
  const bank_details = [
    { label: "Bank Name",           value: uniqueData?.bank_name || "-" },
    { label: "Account Holder Name", value: uniqueData?.account_holder_name || "-" },
    { label: "Account Number",      value: uniqueData?.account_number || "-" },
    { label: "Account Type",        value: uniqueData?.account_type || "-" },
    { label: "Branch Code",         value: uniqueData?.branch_code || "-" },
    { label: "IFSC/SWIFT/IBAN Code",value: uniqueData?.bank_identification_code || "-" },
    { label: "Branch Address",      value: uniqueData?.branch_address || "-" },
  ];
  const statutory_details = [
    { label: "PAN Number",              value: uniqueData?.pan_number || "-" },
    { label: "Tax ID Type",             value: uniqueData?.tax_id_types || "-" },
    { label: "Tax Code",                value: uniqueData?.tax_identification_number || "-" },
    { label: "LUT Number",              value: uniqueData?.lut_number || "-" },
    { label: "LUT Date",                value: uniqueData?.lut_date || "-" },
    { label: "ISO Certification Number",value: uniqueData?.iso_number || "-" },
    { label: "MSME Register Number",    value: uniqueData?.msme_registration_number || "-" },
  ];
  const proprietor_CD = [
    { label: "First Name",             value: uniqueData?.first_name || "-" },
    { label: "Last Name",              value: uniqueData?.last_name || "-" },
    { label: "Designation",            value: uniqueData?.designation || "-" },
    { label: "Official Mobile Number", value: uniqueData?.official_mobile_number || "-" },
    { label: "Official Email Address", value: uniqueData?.official_email_address || "-" },
  ];
  const rep_CD = [
    { label: "First Name",             value: uniqueData?.rep_first_name || "-" },
    { label: "Last Name",              value: uniqueData?.rep_last_name || "-" },
    { label: "Designation",            value: uniqueData?.rep_designation || "-" },
    { label: "Official Mobile Number", value: uniqueData?.rep_official_mobile_number || "-" },
    { label: "Official Email Address", value: uniqueData?.rep_official_email_address || "-" },
  ];
  const finance_rep_CD = [
    { label: "First Name",             value: uniqueData?.financerep_first_name || "-" },
    { label: "Last Name",              value: uniqueData?.financerep_last_name || "-" },
    { label: "Designation",            value: uniqueData?.financerep_designation || "-" },
    { label: "Official Mobile Number", value: uniqueData?.financerep_mobile_num || "-" },
    { label: "Official Email Address", value: uniqueData?.financerep_email || "-" },
  ];
  const documents = buildVendorDocuments(uniqueData).map((doc) => ({
    ...doc,
    value: doc.url,
  }));
  const gstDetails = [
    { label: "GST Number",               value: uniqueData?.tax_identification_number || "-" },
    { label: "Trade Name",               value: uniqueData?.gst_trade_name || "-" },
    { label: "Legal Name",               value: uniqueData?.pan_name || "-" },
    { label: "GST Place of Business",    value: uniqueData?.gst_place_of_business || "-" },
    { label: "Nature of Business",       value: uniqueData?.gst_nature_of_business || "-" },
    { label: "Date of Liability",        value: uniqueData?.gst_date_of_liability || "-" },
    { label: "Date of Validity",         value: uniqueData?.gst_date_of_validity || "-" },
    { label: "Type of Registration",     value: uniqueData?.gst_type_of_registration || "-" },
    { label: "Cancellation Flag",        value: uniqueData?.gst_cancellation_flag || "-" },
  ];
  const panDetails = [
    { label: "PAN Number", value: uniqueData?.pan_number || "-" },
    { label: "PAN Name",   value: uniqueData?.pan_name   || "-" },
  ];
  const msmeDetails = [
    { label: "MSME Register Number", value: uniqueData?.msme_registration_number || "-" },
    { label: "Name of enterprise",   value: uniqueData?.msme_name_of_enterprise  || "-" },
    { label: "Type of enterprise",   value: getMsmeEnterpriseType(uniqueData) || "-" },
    { label: "Major Activity",       value: uniqueData?.msme_major_activity      || "-" },
    { label: "Date of Filing",       value: uniqueData?.msme_date_of_filing      || "-" },
  ];

  const TabDetails = [
    { tabName: "GST Details",    currentTab: tab5, clickFn: tab5Click },
    { tabName: "PAN Details",    currentTab: tab6, clickFn: tab6Click },
    { tabName: "Business Info",  currentTab: tab1, clickFn: tab1Click },
    { tabName: "MSME Details",   currentTab: tab7, clickFn: tab7Click },
    { tabName: "Bank Details",   currentTab: tab2, clickFn: tab2Click },
    { tabName: "Contact Details",currentTab: tab3, clickFn: tab3Click },
    { tabName: "Documents",      currentTab: tab4, clickFn: tab4Click },
    { tabName: "Item Mapping",   currentTab: tab8, clickFn: tab8Click },
  ];

  const toggleDocument = (docUrl) => {
    setSelectedDocs((prev) => prev.includes(docUrl) ? prev.filter((d) => d !== docUrl) : [...prev, docUrl]);
  };

  const handleDownloadSelectedDocs = async () => {
    if (!selectedDocs || selectedDocs.length === 0) return;
    try {
      const zip = new JSZip();
      setLoadingStateDwnload(true);
      for (let i = 0; i < selectedDocs.length; i++) {
        const fileUrl = resolveMediaUrl(selectedDocs[i]);
        if (!fileUrl) continue;
        const fileName = fileUrl.split("/").pop() || `file_${i + 1}`;
        const response = await fetch(fileUrl);
        if (!response.ok) continue;
        const blob = await response.blob();
        zip.file(fileName, blob);
      }
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "Vendor_Documents.zip");
      clearSelectedDocs();
    } catch (error) {
      setPopupHeroText("Unable to Download");
      setPopupMessage("Something went wrong while downloading the selected documents. Please try again.");
      setPopupImage(deletePopupImg);
      setOpenS(true);
    } finally {
      setLoadingStateDwnload(false);
    }
  };

  const clearSelectedDocs = () => setSelectedDocs([]);

  const handleDownloadVendorPdf = async (vendor) => {
    if (!vendor?.token) return;

    setVendorPdfLoadingToken(vendor.token);

    try {
      const sections = buildVendorPdfSections(vendor);
      const exportDate = new Date().toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      const tableSections = sections.filter(
        (section) => section.title !== "Document Link",
      );
      const documentLinks = buildVendorDocumentLinks(vendor);

      const fileName = `vendor-master-${String(vendor?.company_name || vendor?.vendor_code || "record")
        .replace(/\s+/g, "_")
        .replace(/[^\w.-]/g, "")
        .toUpperCase()}-${new Date().toISOString().split("T")[0]}.pdf`;

      await exportStructuredRecordPdf({
        headerTitle: "Supplier Management Record",
        headerSubtitle: "Downloaded from Buyer Supplier Management",
        exportDate,
        summaryRows: [
          ["Company Name", formatCompanyName(vendor?.company_name) || "-"],
          ["Supplier ID", vendor?.vendor_code || "-"],
          [
            "Registered Email",
            vendor?.official_email_address || vendor?.invite_email_address || "-",
          ],
        ],
        sections: tableSections.map((section) => ({
          title: section.title,
          rows: section.rows,
        })),
        documentLinks,
        fileName,
      });
    } catch (error) {
      console.error("Vendor PDF export failed:", error);
      setPopupHeroText("Unable to Download");
      setPopupMessage("Something went wrong while downloading the vendor record. Please try again.");
      setPopupImage(deletePopupImg);
      setOpenS(true);
    } finally {
      setVendorPdfLoadingToken("");
    }
  };

  const getMismatchReason = (vendor) => {
    const issues = [];
    if (vendor?.pan_status  !== "Verified") issues.push("PAN not verified");
    if (vendor?.gst_status  !== "Verified") issues.push("GST not verified");
    if (vendor?.bank_status !== "Verified") issues.push("Cheque not verified");
    if (vendor?.cin_status  === "Mismatch") issues.push("CIN mismatch");
    if (vendor?.msme_status === "Mismatch") issues.push("MSME mismatch");
    return issues.length > 0 ? issues.join(", ") : "Unknown reason";
  };

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;
    const { action, vendor_Master_search } = JSON.parse(chatActionRaw);
    if (action === "export_vendor_master") {
      downloadFile({ key: "org_token", value: Datas?.organization_token, fileNameProp: "Vendors Data", outputFormat: "CSV", API_ENDPOINT: API_ENDPOINT.csv_buyer_vendor_list, authToken: auth_token, setLoadingState: setLoadingStateDwnload });
      sessionStorage.removeItem("CHAT_ACTION");
      return;
    }
    if (action === "search_vendor_details" || action === "search_vendor_master") {
      if (!vendorsData || vendorsData.length === 0) return;
      setSearchQuery(vendor_Master_search || "");
      setPageNumber(1);
      sessionStorage.removeItem("CHAT_ACTION");
    }
  }, [vendorsData]);

  // ── Filter vendors for quick filter ──────────────────────────
  const getFilteredVendors = () => {
    if (!vendorsData) return [];

    let filtered = vendorsData;

    if (activeQuickFilter === "All") return filtered;
    return filtered.filter((v) => {
      const mca   = getMcaStatus(v);
      const score = getRiskScore(v);
      switch (activeQuickFilter) {
        case "Active":            return mca === "ACTIVE" && score <= 25;
        case "Strike-off":        return mca === "STRIKE OFF";
        case "High Risk":         return score > 50;
        case "Dormant":           return mca === "DORMANT";
        case "Under Liquidation": return mca === "UNDER LIQUIDATION";
        default:                  return true;
      }
    });
  };

  const filteredVendors = getFilteredVendors();
  const totalVendorCount = Math.max(
    paginationData?.total_records || 0,
    filteredVendors.length || 0
  );

  // ─────────────────────────────────────────────────────────────
  return (
    <div className={classes.users_tab_wrapper}>

      {/* ── Top header ── */}
      <div className={classes.users_topHeader}>
        <div className={`${classes.lhs} flex`}>
          {vendorMain ? null : (
            <div className={classes.flex} style={{ cursor: "pointer" }} onClick={() => { setVendorMain(true); setOpenViewVendor(false); tab1Click(); }}>
              <ArrowLeft sx={{ fontSize: "30px" }} />
              <HeaderTitle titleText={uniqueLocalData?.company_name} customclass={classes.dashHead} />
            </div>
          )}
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════════
          VENDOR MAIN — Strike-off Monitor UI
      ══════════════════════════════════════════════════════════ */}
      {vendorMain && (
        <>
          {/* Page hero */}
          <div className={classes.pageHero}>
            <div className={classes.pageHeroLeft}>
              <h1 className={classes.pageHeroTitle}>Supplier Master</h1>
              
            </div>
            <div className={classes.pageHeroRight}>
              <span className={classes.syncLabel}>
                Data last synced: just now &nbsp;↻
              </span>
            </div>
          </div>

          {/* KPI cards */}
          <div className={classes.kpiRow}>
            {kpiCards.map((card, i) => (
              <div
                key={card.label}
                className={`${classes.kpiCard} ${classes[`kpiCard_${card.color}`]}`}
                style={{ animationDelay: `${i * 0.07}s` }}
              >
                <div className={classes.kpiCardHeader}>
                  <div className={`${classes.kpiIconWrap} ${classes[`kpiIconWrap_${card.color}`]}`}>
                    {card.icon}
                  </div>
                </div>
                <div className={classes.kpiValueRow}>
                  {kpiLoading ? (
                    <>
                      <span className={`${classes.kpiSkeleton} ${classes.kpiSkeleton_value}`} />
                      <span className={`${classes.kpiSkeleton} ${classes.kpiSkeleton_badge}`} />
                    </>
                  ) : (
                    <>
                      <span className={classes.kpiValue}>{card.value}</span>
                      <span className={`${classes.kpiBadge} ${classes[`kpiBadge_${card.color}`]}`}>
                        {card.badge}
                      </span>
                    </>
                  )}
                </div>
                <span className={classes.kpiLabel}>
                  {kpiLoading ? (
                    <span className={`${classes.kpiSkeleton} ${classes.kpiSkeleton_label}`} />
                  ) : (
                    <Tooltip
                      title={card.hint || ""}
                      arrow
                      slotProps={{ tooltip: { sx: { fontSize: "1.35rem", padding: "8px 12px", fontFamily: "gilroyMedium" } } }}
                    >
                      <span className={classes.kpiLabelText}>{card.label}</span>
                    </Tooltip>
                  )}
                </span>
                <span className={classes.kpiSub}>
                  {kpiLoading ? (
                    <span className={`${classes.kpiSkeleton} ${classes.kpiSkeleton_sub}`} />
                  ) : (
                    card.sub
                  )}
                </span>
              </div>
            ))}
          </div>

          {/* Search + action bar */}
          <div className={classes.search_add_wrapper}>
            <div className={classes.searchFilterRow}>
              <SearchBar
                value={searchQuery}
                onChange={(query) => {
                  setSearchQuery(query);
                  setPageNumber(1);
                }}
                placeholder="Search by supplier name, contact person, or email"
                tooltip="Search by supplier name, contact person, or email"
              />
            </div>
            <div className={classes.actionBtns}>
              <DropdownBtnOutlined
                label="DOWNLOAD AS"
                btnHeight="4rem"
                btnWidth="16rem"
                loadingState={loadingStateDwnload}
                disabled={vendorsData?.length === 0}
                onClick={(fileFormat) => {
                  downloadFile({ key: "org_token", value: Datas?.organization_token, fileNameProp: "Vendors Data", outputFormat: fileFormat, API_ENDPOINT: API_ENDPOINT.csv_buyer_vendor_list, authToken: auth_token, setLoadingState: setLoadingStateDwnload });
                }}
                options={["CSV", "PDF"]}
              />
              <Dbutton iconWidth="1rem" iconHeight="1rem" label="UPLOAD" btnHeight="4rem" buyerBtn={true} onClick={handleOpenAddBulkItem} />
              <DButton labelImg={plusIcon} iconHeight={"15px"} iconwidth={"15px"} label="Add Suppliers" btnHeight="4rem" buyerBtn={true} onClick={handleOpen} />
            </div>
          </div>

          {/* Quick filter chips */}
          <div className={classes.quickFilterRow}>
            <span className={classes.quickFilterLabel}>Quick Filters:</span>
            {quickFilters.map((f) => (
              <button
                key={f.label}
                className={`${classes.filterChip} ${activeQuickFilter === f.label ? classes.filterChip_active : ""}`}
                onClick={() => setActiveQuickFilter(activeQuickFilter === f.label ? "All" : f.label)}
              >
                <span className={classes.filterDot} style={{ background: f.dot }} />
                {f.label}
              </button>
            ))}
          </div>
          {activeQuickFilter !== "All" && (
            <div className={classes.filterSummaryBar}>
              <span className={classes.filterSummaryText}>
                Filter: <strong>{activeQuickFilter}</strong> ({filteredVendors.length})
              </span>
              <button className={classes.filterClearBtn} onClick={() => setActiveQuickFilter("All")}>
                Clear
              </button>
            </div>
          )}

          {/* Main content: table + detail panel */}
          <div className={classes.mainContent}>

            {/* Table panel */}
            <div className={classes.tablePanel}>
              <div className={classes.tablePanelHeader}>
                <span className={classes.tablePanelInfo}>
                  Showing <strong>1 to {filteredVendors.length}</strong> of{" "}
                  <strong>{totalVendorCount}</strong> vendors
                </span>
              </div>

              <div style={{ overflowX: "auto" }}>
                <table className={classes.vendorTable}>
                  <thead>
                    <tr>
                      <th>Company Name</th>
                      <th>Contact Person</th>
                      <th>PAN</th>
                      <th>GSTIN</th>
                      <th>Registered Email</th>
	                      <th>Invite Email</th>
	                      <th>Supplier ID</th>
	                      <th onClick={toggleCreatedDateSort}>
	                        <span style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem" }}>
	                          Created Date
	                          {sortingColumnName === "created_date" && (
	                            <span style={{ fontSize: "1.2rem", color: "#64748b" }}>
	                              {sortingOrder === "asc" ? "▲" : "▼"}
	                            </span>
	                          )}
	                        </span>
	                      </th>
	                      <th>
	                        <Tooltip
	                          title="MCA status is derived from MCA/CIN checks (active, strike-off, liquidation, etc.)."
	                          arrow
                          slotProps={{ tooltip: { sx: { fontSize: "1.3rem", padding: "8px 12px" } } }}
                        >
                          <span className={classes.headerWithTooltip}>
                            MCA Status
                            <br />
                            <span style={{ fontFamily: "gilroyMedium", color: "#94a3b8", fontSize: "1.15rem" }}>
                              As On
                            </span>
                          </span>
                        </Tooltip>
                      </th>
                      <th>
                        <Tooltip
                          title="Compliance is based on PAN, GST, and Bank verification. Verified means all three are verified."
                          arrow
                          slotProps={{ tooltip: { sx: { fontSize: "1.3rem", padding: "8px 12px" } } }}
                        >
                          <span className={classes.headerWithTooltip}>
                            Compliance
                            <br />
                            <span style={{ fontFamily: "gilroyMedium", color: "#94a3b8", fontSize: "1.15rem" }}>
                              Last Filed
                            </span>
                          </span>
                        </Tooltip>
                      </th>
                      <th>Onboarding Status</th>
                      <th>Reverify</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableProps.isLoading ? (
                      <tr>
                        <td colSpan={13} style={{ textAlign: "center", padding: "3rem", color: "#94a3b8", fontFamily: "gilroyMedium", fontSize: "1.3rem" }}>
                          Loading vendors...
                        </td>
                      </tr>
                    ) : filteredVendors.length === 0 ? (
                      <tr>
                        <td colSpan={13} style={{ textAlign: "center", padding: "3rem", color: "#94a3b8", fontFamily: "gilroyMedium", fontSize: "1.3rem" }}>
                          No vendors found
                        </td>
                      </tr>
                    ) : (
                      filteredVendors.map((vendor) => {
                        const mcaStatus    = getMcaStatus(vendor);
                        const compliance   = getComplianceStatus(vendor);
                        const companyName  = formatCompanyName(vendor.company_name);
                        const complianceLabel =
                          compliance === "Compliant"
                            ? "Verified"
                            : compliance === "Non-Compliant"
                            ? "Not Verified"
                            : "N/A";
                        const onboardingStatus = getOnboardingStatus(vendor);
                        const contactName = [vendor.first_name, vendor.last_name]
                          .filter(Boolean)
                          .join(" ")
                          .trim() || vendor.full_name || "-";
                        const isDetailOpen = selectedVendorDetail?.token === vendor.token;

                        return (
                          <tr
                            key={vendor.token}
                            className={isDetailOpen ? classes.rowSelected : ""}
                            onClick={() => {
                              setSelectedVendorDetail(isDetailOpen ? null : vendor);
                              setDetailTab("Overview");
                            }}
                          >
                            <td>
                              <div className={classes.vendorNameCell}>
                                <span className={classes.vendorNamePrimary}>
                                  {companyName || "-"}
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className={classes.contactCell}>
                                <span className={classes.contactPrimary}>{contactName}</span>
                                <span className={classes.contactSecondary}>{vendor.role || "-"}</span>
                              </div>
                            </td>

                            <td>
                              <span className={classes.simpleCell}>{vendor.pan_number || "-"}</span>
                            </td>

                            <td>
                              <span className={classes.simpleCell}>{vendor.tax_identification_number || "-"}</span>
                            </td>

                            <td>
                              <span className={classes.emailCell}>{vendor.official_email_address || "-"}</span>
                            </td>

                            <td>
                              <span className={classes.emailCell}>{vendor.invite_email_address || "-"}</span>
                            </td>

                            <td>
                              <span className={classes.simpleCell}>{vendor.vendor_code || "-"}</span>
                            </td>

                            <td>
                              <span className={classes.simpleCell}>{formatDate(vendor.created_on)}</span>
                            </td>

                            <td>
                              <span className={`${classes.statusBadge} ${classes[getMcaStatusStyle(mcaStatus)]}`}>
                                <span className={`${classes.statusDot} ${classes[getMcaDotStyle(mcaStatus)]}`} />
                                {mcaStatus}
                              </span>
                            </td>

                            <td>
                              <span className={`${classes.complianceBadge} ${compliance === "Compliant" ? classes.complianceBadge_ok : compliance === "N/A" ? classes.complianceBadge_na : classes.complianceBadge_bad}`}>
                                {complianceLabel}
                              </span>
                            </td>

                            <td>
                              <span
                                className={`${classes.onboardingBadge} ${
                                  onboardingStatus === "Fully Onboarded"
                                    ? classes.onboardingBadge_full
                                    : classes.onboardingBadge_partial
                                }`}
                              >
                                {onboardingStatus}
                              </span>
                            </td>

                            <td onClick={(e) => e.stopPropagation()}>
                              {onboardingStatus === "Partially Onboarded" ? (
                                <Tooltip title={getMismatchReason(vendor)} placement="top" slotProps={tooltipSlotProps}>
                                  <button
                                    className={classes.reverifyBtn}
                                    onClick={() => reverifyVendor(vendor.official_email_address)}
                                  >
                                    Reverify
                                  </button>
                                </Tooltip>
                              ) : (
                                <span className={classes.simpleCell}>-</span>
                              )}
                            </td>

                            <td onClick={(e) => e.stopPropagation()}>
                              <div className={classes.actionsCell}>
                                <Tooltip title="View Details" placement="top" slotProps={tooltipSlotProps}>
                                  <button
                                    className={classes.iconBtn}
                                    onClick={() => viewVendorClick(vendor.token, vendor)}
                                  >
                                    <Visibility className={classes.viewIcon} />
                                  </button>
                                </Tooltip>
                                <Tooltip title="Download PDF" placement="top" slotProps={tooltipSlotProps}>
                                  <button
                                    className={classes.iconBtn}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDownloadVendorPdf(vendor);
                                    }}
                                    disabled={vendorPdfLoadingToken === vendor.token}
                                    aria-label="Download vendor PDF"
                                  >
                                    <FileDownloadOutlined className={classes.viewIcon} />
                                  </button>
                                </Tooltip>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

              {/* Table footer with existing pagination */}
              <div className={classes.tableFooter}>
                <span className={classes.tableFooterInfo}>
                  Showing {filteredVendors.length} of {totalVendorCount} vendors
                </span>
                <PaginationComponent
                  pageNumber={pageNumber}
                  currentPage={currentPage || 0}
                  itemsPerPage={itemsPerPage || 0}
                  totalItems={totalItems || 0}
                  setPageNumber={setPageNumber}
                  previouPageClick={() => previouPageClick(pageNumber, setPageNumber)}
                  nextPageClick={() => nextPageClick(pageNumber, setPageNumber, paginationData)}
                  disablePrevious={parseInt(pageNumber) === 1 || pageNumber === ""}
                  disableNext={parseInt(pageNumber) === paginationData?.page_count || !paginationData || pageNumber === ""}
                />
              </div>
            </div>

            {/* ── Detail side panel ── */}
            {selectedVendorDetail && (() => {
              const v     = selectedVendorDetail;
              const mca   = getMcaStatus(v);
              const reco  = getRecommendation(v);
              const flags = getRiskFlags(v);
              const detailDocuments = buildVendorDocuments(v);
              const displayCompanyName = formatCompanyName(v.company_name);
              const displayVendorCode = String(v.vendor_code || "").trim();
              const isPendingMca = mca === "PENDING";
              const panStatusChip = v?.pan_status === "Verified" ? "identityStatusChip_valid" : "identityStatusChip_pending";
              const gstStatusChip = v?.gst_status === "Verified" ? "identityStatusChip_active" : "identityStatusChip_pending";
              const cinStatusChip = v?.cin_status === "Mismatch" ? "identityStatusChip_invalid" : v?.company_registration_number ? "identityStatusChip_active" : "identityStatusChip_pending";

              return (
                <div className={classes.detailPanel}>
                  {/* Panel header */}
                  <div className={classes.detailPanelHeader}>
                    <div className={classes.detailPanelCompany}>
                      <div className={classes.detailPanelAvatar}>
                        {displayVendorCode || getCompanyInitials(displayCompanyName || v.company_name || "")}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.7rem", flexWrap: "wrap" }}>
                        <span className={classes.detailPanelName}>{displayCompanyName || "—"}</span>
                        <span className={`${classes.statusBadge} ${classes[getMcaStatusStyle(mca)]}`} style={{ fontSize: "1.2rem", padding: "0.2rem 0.7rem" }}>
                          <span className={`${classes.statusDot} ${classes[getMcaDotStyle(mca)]}`} />
                          {mca}
                        </span>
                      </div>
                      <span className={classes.detailPanelTypeLine}>{v.company_type || "Private Limited"}</span>
                    </div>
                    <button
                      className={classes.detailPanelClose}
                      onClick={() => setSelectedVendorDetail(null)}
                    >
                      ✕
                    </button>
                  </div>

                  <div className={classes.detailPanelEntityId}>
                    Enttity ID (CIN): {v.company_registration_number || v.corporate_identity_number || "—"}
                  </div>

                  {/* Tabs (hide for Pending, keep only Overview content) */}
                  {!isPendingMca && (
                    <div className={classes.detailTabRow}>
                      {["Overview", "Compliance", "Contacts", "Documents"].map((t) => (
                        <button
                          key={t}
                          className={`${classes.detailTab} ${detailTab === t ? classes.detailTab_active : ""}`}
                          onClick={() => setDetailTab(t)}
                        >
                          {t}
                        </button>
                      ))}
                    </div>
                  )}

                  {/* Overview tab */}
                  {(isPendingMca || detailTab === "Overview") && (
                    <div className={classes.detailPanelBody}>
                      {/* PAN / GSTIN / CIN */}
                      <div className={classes.identityRow}>
                        <div className={classes.identityCell}>
                          <span className={classes.identityKey}>PAN</span>
                          <span className={classes.identityVal}>{v.pan_number || "—"}</span>
                          <span className={`${classes.identityStatusChip} ${classes[panStatusChip]}`}>
                            + {v.pan_status || "Pending"}
                          </span>
                        </div>
                        <div className={classes.identityCell}>
                          <span className={classes.identityKey}>GSTIN</span>
                          <span className={classes.identityVal} style={{ fontSize: "1.2rem" }}>{v.tax_identification_number || "—"}</span>
                          <span className={`${classes.identityStatusChip} ${classes[gstStatusChip]}`}>
                            + {v.gst_status || "Pending"}
                          </span>
                        </div>
                        <div className={classes.identityCell}>
                          <span className={classes.identityKey}>CIN</span>
                          <span className={classes.identityVal} style={{ fontSize: "1.2rem" }}>{v.company_registration_number || "—"}</span>
                          <span className={`${classes.identityStatusChip} ${classes[cinStatusChip]}`}>
                            + {v.cin_status || (v.company_registration_number ? "Active" : "Pending")}
                          </span>
                        </div>
                      </div>

                      {/* MCA / address details */}
                      <div className={classes.detailInfoRow}>
                        <div className={classes.detailInfoItem}>
                          <span className={classes.detailInfoKey}>MCA Status</span>
                          <span className={`${classes.statusBadge} ${classes[getMcaStatusStyle(mca)]}`} style={{ fontSize: "1.2rem" }}>
                            <span className={`${classes.statusDot} ${classes[getMcaDotStyle(mca)]}`} />
                            {mca}
                          </span>
                        </div>
                        <div className={classes.detailInfoItem}>
                          <span className={classes.detailInfoKey}>Created Date</span>
                          <span className={classes.detailInfoVal}>{v.created_on ? new Date(v.created_on).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—"}</span>
                        </div>
                        <div className={classes.detailInfoItem}>
                          <span className={classes.detailInfoKey}>Email</span>
                          <span className={classes.detailInfoVal} style={{ fontSize: "1.2rem", maxWidth: "14rem", wordBreak: "break-all", textAlign: "right" }}>{v.company_official_email || v.official_email_address || "—"}</span>
                        </div>
                        <div className={classes.detailInfoItem}>
                          <span className={classes.detailInfoKey}>Registered Address</span>
                          <span className={classes.detailInfoVal} style={{ fontSize: "1.2rem", maxWidth: "14rem", textAlign: "right" }}>{formatVendorAddress(v)}</span>
                        </div>
                      </div>

                      {/* Risk flags */}
                      {flags.length > 0 && (
                        <div className={classes.riskFlagsSection}>
                          <p className={classes.riskFlagsTitle}>Verification Flags</p>
                          <div className={classes.riskFlagsList}>
                            {flags.map((f, i) => (
                              <span key={i} className={`${classes.riskFlag} ${classes[f.color]}`}>
                                {f.label}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Recommendation box */}
                      <div className={`${classes.recoBox} ${classes[`recoBox_${reco.color}`]}`}>
                        <div className={`${classes.recoBoxTitle} ${classes[`recoBoxTitle_${reco.color}`]}`}>
                          {reco.color === "green" ? "✓" : reco.color === "red" ? "⚠" : "●"} {reco.primary}
                        </div>
                        <p className={classes.recoBoxDesc}>
                          {reco.color === "green"
                            ? "Supplier is compliant with MCA and GST records. No strike-off risk identified."
                            : reco.color === "red"
                            ? "Supplier has critical compliance issues. Recommend blocking until resolved."
                            : "Supplier has pending verifications. Monitor closely before proceeding."}
                        </p>
                      </div>

                      {/* View full details */}
                      <button
                        className={classes.viewFullBtn}
                        onClick={() => viewVendorClick(v.token, v)}
                      >
                        View Full Details ↗
                      </button>
                    </div>
                  )}

                  {/* Compliance tab */}
                  {!isPendingMca && detailTab === "Compliance" && (
                    <div className={classes.detailPanelBody}>
                      <div className={classes.detailInfoRow}>
                        {[
                          { key: "PAN Status",   val: v.pan_status  || "—" },
                          { key: "GST Status",   val: v.gst_status  || "—" },
                          { key: "Bank Status",  val: v.bank_status || "—" },
                          { key: "CIN Status",   val: v.cin_status  || "—" },
                          { key: "MSME Status",  val: v.msme_status || "—" },
                          { key: "Supplier ID",  val: v.vendor_code || "—" },
                          { key: "GST Type",     val: v.gst_type_of_registration || "—" },
                          { key: "Nature of Biz",val: v.gst_nature_of_business   || "—" },
                        ].map((item) => (
                          <div key={item.key} className={classes.detailInfoItem}>
                            <span className={classes.detailInfoKey}>{item.key}</span>
                            <span className={classes.detailInfoVal}>{item.val}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Contacts tab */}
                  {!isPendingMca && detailTab === "Contacts" && (
                    <div className={classes.detailPanelBody}>
                      <div className={classes.directorsSectionTitle} style={{ marginBottom: "0.8rem" }}>Proprietor</div>
                      <div className={classes.detailInfoRow}>
                        {[
                          { key: "Name",        val: `${v.first_name || ""} ${v.last_name || ""}`.trim() || "—" },
                          { key: "Designation", val: v.designation || "—" },
                          { key: "Mobile",      val: v.official_mobile_number || "—" },
                          { key: "Email",       val: v.official_email_address || "—" },
                        ].map((item) => (
                          <div key={item.key} className={classes.detailInfoItem}>
                            <span className={classes.detailInfoKey}>{item.key}</span>
                            <span className={classes.detailInfoVal}>{item.val}</span>
                          </div>
                        ))}
                      </div>
                      {v.rep_first_name && (
                        <>
                          <div className={classes.directorsSectionTitle} style={{ margin: "1rem 0 0.8rem" }}>Representative</div>
                          <div className={classes.detailInfoRow}>
                            {[
                              { key: "Name",        val: `${v.rep_first_name || ""} ${v.rep_last_name || ""}`.trim() || "—" },
                              { key: "Designation", val: v.rep_designation || "—" },
                              { key: "Mobile",      val: v.rep_official_mobile_number || "—" },
                              { key: "Email",       val: v.rep_official_email_address || "—" },
                            ].map((item) => (
                              <div key={item.key} className={classes.detailInfoItem}>
                                <span className={classes.detailInfoKey}>{item.key}</span>
                                <span className={classes.detailInfoVal}>{item.val}</span>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  )}

                  {/* Documents tab */}
                  {!isPendingMca && detailTab === "Documents" && (
                    <div className={classes.detailPanelBody}>
                      {detailDocuments.map((doc, i) => (
                        <div key={i} className={classes.detailInfoItem}>
                          <span className={classes.detailInfoKey}>{doc.label}</span>
                          {doc.url ? (
                            <a
                              href={
                                isPdfUrl(doc.url)
                                  ? `https://docs.google.com/gview?url=${encodeURIComponent(doc.url)}&embedded=true`
                                  : doc.url
                              }
                              target="_blank"
                              rel="noreferrer"
                              style={{ color: "#3b82f6", fontSize: "1.3rem", fontFamily: "gilroyMedium" }}
                            >
                              View ↗
                            </a>
                          ) : (
                            <span className={classes.detailInfoVal} style={{ color: "#94a3b8" }}>Not uploaded</span>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        </>
      )}

      {/* ══════════════════════════════════════════════════════════
          VIEW VENDOR DETAIL — completely untouched
      ══════════════════════════════════════════════════════════ */}
      {openViewVendor && (
        <>
          <div className={classes.ViewVendorHeader}>
            {TabDetails.map((tab, index) => (
              <DetailsTab key={index} large={true} tabName={tab.tabName} currentTab={tab.currentTab} clickFn={tab.clickFn} />
            ))}
          </div>

          {tab1 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Business Info"} />
                <div className={classes.info}>
                  {business_info.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Address"} />
                <div className={classes.info}>
                  {address.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Contact Info"} />
                <div className={classes.info}>
                  {contact_info.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Blacklist Checks"} />
                <div className={classes.info}>
                  {vendor_onboarding_blacklist.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
              {isCinCompany && hasTdsFinancials && (
                <div className={classes.infoSection}>
                  <HeaderTitle customclass={classes.tabHeading} titleText={"TDS Corporate Financials"} />
                  <div className={classes.info}>
                    {tdsFinancials.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                  </div>
                </div>
              )}
            </div>
          )}

          {tab2 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Bank Details"} />
                <div className={classes.info}>
                  {bank_details.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Statutory Details"} />
                <div className={classes.info}>
                  {statutory_details.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
            </div>
          )}

          {tab3 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Proprietor Contact Details"} />
                <div className={classes.info}>
                  {proprietor_CD.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Representative Contact Details"} />
                <div className={classes.info}>
                  {rep_CD.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Finance Representative Contact Details"} />
                <div className={classes.info}>
                  {finance_rep_CD.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
            </div>
          )}

          {tab4 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <HeaderTitle customclass={classes.tabHeading} titleText={"Supplier Documents"} />
                  <div style={{ marginBottom: "1rem", display: "flex", gap: "1rem", alignItems: "center", justifyContent: "end" }}>
                    {selectedDocs.length > 0 && (
                      <DButtonOutlined label="Clear Selection" btnHeight="3.5rem" buyerBtnOutline={true} onClick={clearSelectedDocs} />
                    )}
                    <DButton label="Download Selected" btnHeight="3.5rem" buyerBtn={true} disabled={selectedDocs.length === 0} onClick={handleDownloadSelectedDocs} />
                  </div>
                </div>
                <div className={`${classes.infoImageFrame} ${classes.fStart}`}>
                  {documents.map((doc, i) => (
                    <div key={i} style={{ width: "18rem", marginRight: "2rem" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <input
                          type="checkbox"
                          checked={doc.value ? selectedDocs.includes(doc.value) : false}
                          disabled={!doc.value}
                          onChange={() => doc.value && toggleDocument(doc.value)}
                        />
                      </label>
                      <ImageView
                        imgSrc={doc.value}
                        label={doc.label}
                        usePdfThumbnail={true}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {tab5 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"GST Details"} />
                <div className={classes.info}>
                  {gstDetails.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
            </div>
          )}

          {tab6 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"PAN Details"} />
                <div className={classes.info}>
                  {panDetails.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
            </div>
          )}

          {tab7 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"MSME Details"} />
                <div className={classes.info}>
                  {msmeDetails.map((e, i) => (<InfoLabel isLoading={loadingState} key={i} label={e.label} value={e.value} size={"22rem"} />))}
                </div>
              </div>
            </div>
          )}

          {tab8 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText={"Item Mapping"} />
                <VendorItemMapping org_token={organization_token} auth_token={auth_token} dispatch={dispatch} vendorToken={vendorUserToken} />
              </div>
            </div>
          )}
        </>
      )}

      {/* ── Modals — ALL UNTOUCHED ────────────────────────────── */}
      <Modal open={open} closeAfterTransition slotProps={{ backdrop: { TransitionComponent: Fade } }} sx={{ overflow: "auto" }}>
        <Fade in={open}>
          <div className={classes.flex} style={{ height: "100vh" }}>
            <PopupFrame customClass={classes.InviteVendorPopup} styleCenterDiv={classes.centerDiv} inputChildren={vendorsTabInputs} poupHeading={vendorsTabHeading} actionButtons={popupActions} closePopup={handleClose} />
          </div>
        </Fade>
      </Modal>

      <Modal open={openS}>
        <Fade in={openS}>
          <Box>
            <SuccessPopupDashboard popupImage={popupImage} popupHeroText={popupHeroText} popupDescription={popupMessage} popBtn={true} buyerBtn={true} buyerBtnOutline={true} btnText={"Okay"} btnClick={handleCloseS} />
          </Box>
        </Fade>
      </Modal>

      <Modal open={openDltConfirmation}>
        <Box>
          <SuccessPopupDashboard popupImage={deletePopupImg} popupHeroText={popupHeroText} popupDescription={popupMessage} popBtn={true} btnText={"Delete"} secondaryBtn={true} btnTextSecondary={"Cancel"} btnClick={handleDeleteVendor} buyerBtn={true} buyerBtnOutline={true} btnClickSecondary={handleCloseDltConfirmation} />
        </Box>
      </Modal>

      <Modal open={openDlt}>
        <Box>
          <SuccessPopupDashboard popupImage={deletePopupImg} popupHeroText={popupHeroText} popupDescription={popupMessage} popBtn={true} btnText={"Okay"} loadingPrimaryBtn={loadingState} buyerBtn={true} buyerBtnOutline={true} btnClick={handleCloseDlt} />
        </Box>
      </Modal>
    </div>
  );
};

export default BuyerVendorsTab;

